export default "__VITE_ASSET__dffc989a__"